import { Component, Input } from '@angular/core';

@Component({
  selector: 'lp2-bubble-popup',
  templateUrl: './bubble-popup.component.html',
  styleUrls: ['./bubble-popup.component.scss'],
})
export class BubblePopupComponent {
  @Input()
  isSquare = false;
}



// WEBPACK FOOTER //
// ./ts/app/shared/bubble-popup/bubble-popup.component.ts